import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@4.3.0_webpack@3.12.0/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-hzhzk",
  "use": "icon-hzhzk-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-hzhzk\"><path d=\"M901.12 128l-381.44-76.8h-12.8-2.56l-381.44 76.8c-12.8 2.56-20.48 12.8-20.48 25.6v332.8c0 253.44 202.24 435.2 404.48 486.4h10.24c199.68-51.2 404.48-232.96 404.48-486.4v-332.8c0-12.8-7.68-23.04-20.48-25.6z m-30.72 358.4c0 222.72-179.2 386.56-358.4 435.2-179.2-48.64-358.4-209.92-358.4-435.2v-312.32l358.4-71.68 358.4 71.68V486.4z\" p-id=\"3544\" /><path d=\"M325.12 468.48c-10.24-10.24-25.6-10.24-35.84 0s-10.24 25.6 0 35.84l153.6 153.6c5.12 5.12 12.8 7.68 17.92 7.68s12.8-2.56 17.92-7.68l256-256c10.24-10.24 10.24-25.6 0-35.84s-25.6-10.24-35.84 0l-238.08 238.08-135.68-135.68z\" p-id=\"3545\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/hzhzk.svg
// module id = 8t1N
// module chunks = 38